import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const KeyboardActions = createActionGroup({
  source: 'Keyboard',
  events: {
    'Will Show': props<{ height: number }>(),
    'Did Show': emptyProps(),
    'Will Hide': emptyProps(),
    'Did Hide': emptyProps()
  }
});
